<script>
	import { Section } from "$lib/components/organisms/Section";
	import { Button } from "$lib/components/atoms/Button";
</script>

<main>
  <Section>
    <div class="flex flex-col items-center justify-center space-y-6">
      <h1>404 - Pagina non trovata</h1>
      <p class="subtitle text-center">
        OOPS! LA PAGINA CHE STAI CERCANDO NON ESISTE OPPURE È STATA RIMOSSA, CLICCA IL BOTTONE PER TORNARE ALLA HOME PAGE.
      </p>
      <Button kind="secondary" href="/">
        Torna alla homepage
      </Button>
    </div>
  </Section>
</main>